(() => {
  const FORM_STATE_KEY = '__productFormGateState';

  function getFormState(form) {
    if (!form[FORM_STATE_KEY]) {
      form[FORM_STATE_KEY] = {
        requirements: {},
      };
    }

    return form[FORM_STATE_KEY];
  }

  function setRequirement(form, source, payload = {}) {
    if (!(form instanceof HTMLFormElement) || !source) return;
    const state = getFormState(form);
    state.requirements[source] = {
      required: Boolean(payload.required),
      valid: Boolean(payload.valid),
      message: payload.message || '',
    };

    evaluateForm(form);
  }

  function evaluateForm(form) {
    if (!(form instanceof HTMLFormElement)) return;
    const state = getFormState(form);
    const requirements = Object.values(state.requirements);
    const hasUnmetRequirement = requirements.some((item) => item.required && !item.valid);
    const variantInput = form.querySelector('input[name="id"]');
    const isUnavailable = Boolean(variantInput?.disabled);
    const shouldLock = !isUnavailable && hasUnmetRequirement;

    toggleAddToCartLock(form, shouldLock, isUnavailable);
    toggleDynamicCheckoutLock(form, shouldLock);
  }

  function toggleAddToCartLock(form, shouldLock, isUnavailable) {
    const addButton = form.querySelector('button[name="add"][type="submit"], input[name="add"][type="submit"]');
    if (!addButton) return;

    if (shouldLock) {
      addButton.dataset.formGateLock = 'true';
      addButton.setAttribute('disabled', 'disabled');
      addButton.setAttribute('aria-disabled', 'true');
      return;
    }

    if (addButton.dataset.formGateLock !== 'true') return;
    delete addButton.dataset.formGateLock;
    addButton.removeAttribute('aria-disabled');

    if (!isUnavailable) {
      addButton.removeAttribute('disabled');
    }
  }

  function toggleDynamicCheckoutLock(form, shouldLock) {
    const paymentContainer = form.querySelector('.shopify-payment-button');
    if (!paymentContainer) return;

    if (shouldLock) {
      if (paymentContainer.dataset.formGateLock !== 'true') {
        paymentContainer.dataset.formGateLock = 'true';
        paymentContainer.dataset.formGatePointerEvents = paymentContainer.style.pointerEvents || '';
        paymentContainer.dataset.formGateOpacity = paymentContainer.style.opacity || '';
      }

      paymentContainer.style.pointerEvents = 'none';
      paymentContainer.style.opacity = '0.5';
      paymentContainer.setAttribute('aria-disabled', 'true');
      return;
    }

    if (paymentContainer.dataset.formGateLock !== 'true') return;
    paymentContainer.style.pointerEvents = paymentContainer.dataset.formGatePointerEvents || '';
    paymentContainer.style.opacity = paymentContainer.dataset.formGateOpacity || '';
    paymentContainer.removeAttribute('aria-disabled');

    delete paymentContainer.dataset.formGatePointerEvents;
    delete paymentContainer.dataset.formGateOpacity;
    delete paymentContainer.dataset.formGateLock;
  }

  function refreshBySectionId(sectionId) {
    if (!sectionId) return;
    const form = document.getElementById(`product-form-${sectionId}`);
    if (!form) return;
    bindPersonalizationRequirement(form);
    syncPersonalizationRequirement(form);
    evaluateForm(form);
  }

  function refreshAll() {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
      bindPersonalizationRequirement(form);
      syncPersonalizationRequirement(form);
      evaluateForm(form);
    });
  }

  function getPersonalizationInput(form) {
    const inForm = form.querySelector('input[name="properties[Personalisierung]"]');
    if (inForm) return inForm;
    if (!form.id) return null;
    return document.querySelector(
      `input[name="properties[Personalisierung]"][form="${CSS.escape(form.id)}"]`
    );
  }

  function syncPersonalizationRequirement(form) {
    const personalizationInput = getPersonalizationInput(form);
    if (!personalizationInput) {
      setRequirement(form, 'personalization', { required: false, valid: true });
      return;
    }

    const isValid = Boolean(String(personalizationInput.value || '').trim());
    setRequirement(form, 'personalization', { required: true, valid: isValid });
  }

  function bindPersonalizationRequirement(form) {
    const personalizationInput = getPersonalizationInput(form);
    if (!personalizationInput) {
      form.dataset.personalizationGateBound = 'false';
      return;
    }

    if (personalizationInput.dataset.personalizationGateBound === 'true') return;
    personalizationInput.dataset.personalizationGateBound = 'true';

    const onInput = () => syncPersonalizationRequirement(form);
    personalizationInput.addEventListener('input', onInput);
    personalizationInput.addEventListener('change', onInput);
  }

  function installEventBridge() {
    document.addEventListener('product-form-gate:update', (event) => {
      const detail = event?.detail || {};
      setRequirement(detail.form, detail.source, detail);
    });

    document.addEventListener('product-info:loaded', () => {
      refreshAll();
    });

    if (typeof subscribe === 'function') {
      subscribe('variant-change', ({ data }) => {
        refreshBySectionId(data?.sectionId);
      });
    }
  }

  installEventBridge();
  refreshAll();
  window.ProductFormGate = {
    setRequirement,
    evaluateForm,
    refreshAll,
    refreshBySectionId,
  };
})();
